'use client';

import Link from 'next/link';

import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { MdOutlineAccountCircle } from 'react-icons/md';

export const HeaderProfileButton = () => {
  const { t } = useTranslations();
  const me = useCustomerStore(s => s.me);

  const openDialog = useDialogStore(s => s.open);

  const handleSignInClick = () => {
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!me) {
    return (
      <Button variant={'none'} size={'none'} onClick={handleSignInClick} className="font-bold">
        {t('text190')}
      </Button>
    );
  }

  return (
    <Button asChild variant={'none'} size={'none'}>
      <Link prefetch={false} href={ROUTES.PROFILE()}>
        <MdOutlineAccountCircle size={24} className="text-foreground" />
      </Link>
    </Button>
  );
};
